module.exports = __webpack_public_path__ + "static/media/user-photo.972da7ba.svg";